import { Component, OnInit } from '@angular/core';
import { Organization } from 'src/app/models';
import { OrganizationService } from 'src/app/services';

@Component({
  selector: 'app-sidebar-services',
  templateUrl: './sidebar-services.component.html',
  styleUrls: ['./sidebar-services.component.css']
})
export class SidebarServicesComponent implements OnInit {

  toggleOpen: boolean = false;
  org: Organization;
  constructor(private _organizationService: OrganizationService) { }

  ngOnInit(): void {
    if(!this._organizationService.organization){
      this._organizationService.getCurrentOrg(false).subscribe(
        (res: Organization) => this.org = res,
      )
    } else {
      this.org = this._organizationService.organization
    }
  }

  checkTeamVehicle() {
    const url = window.location.href;
    if (url.includes('/services/teams') || url.includes('/services/vehicles') || url.includes('/services/team-vehicle')) {
      return true;
    }
  }

}
